
import { ref, unref, defineComponent, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';

/* Npm Plugins */
import { ElMessage } from 'element-plus';
import { DocumentEditor, IConfig } from '@onlyoffice/document-editor-vue';

/* Configs */
import { config } from '@/config/config';

/* Hooks & Stores */
import { useAppStore } from '@/store/app';
import { useWatermark } from '@/hooks/useWatermark';

/* Apis */
import { GetEditorCfgApi, GetHistoryDataApi, GetHistoryInfoApi } from '../../apis/materials/material.api';

export default defineComponent({
	components: { DocumentEditor },
	setup() {
		const { onlyOffice } = config;
		const { params } = useRoute();
		const { setWatermark, clear } = useWatermark();

		const isConfigLoaded = ref(false);
		const docJsApi = ref<string>(onlyOffice);
		const editorConfig = ref<Nullable<IConfig>>();

		const login = useAppStore().getLoginInfo;

		const state = reactive({
			historyInfoList: [],
			historyDataList: [],
		});

		/* 读取Editor编辑器配置 */
		async function loadingConfig(rotId: string, deviceType: number) {
			const res = await GetEditorCfgApi({ material_id: rotId, device: deviceType });

			if (!res.succeeded) {
				ElMessage.error(`读取文档失败，可能的原因是：${res.errors}`);
			} else {
				editorConfig.value = res.data as IConfig;

				const hisListRes = await GetHistoryDataApi(rotId);
				const hisDataRes = await GetHistoryInfoApi(rotId, 0);

				state.historyInfoList = hisListRes.data || null;
				state.historyDataList = hisDataRes.data || null;

				isConfigLoaded.value = true;
			}
		}

		/* Editor方法集合 */
		const methods = {
			/* 添加水印 */
			onAppReady: (event: any) => {
				setWatermark(`${login.user_name}(${login.user_account})`);
			},

			requestHistory: async (events: any, pr: any) => {
				const editors = window.DocEditor?.instances.docEditor;
				if (editors) {
					editors.refreshHistory(state.historyInfoList);
				}
			},

			requestHistoryData: async (events: any) => {
				const version = events.data;
				const historyData = state.historyDataList[version - 1];

				const editors = window.DocEditor?.instances.docEditor;

				if (editors && historyData) {
					editors.setHistoryData(historyData);
				}
			},

			onHistoryClosed: () => {
				document.location.reload();
			},

			requestCompareFile: () => {
				const editors = window.DocEditor?.instances.docEditor;
				// editors.setRevisedFile({
				//     "fileType": "docx",
				//     "url": "https://onlyoffice.voion.com/example/assets/sample/sample.docx",
				//     "directUrl": null,
				//     "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmaWxlVHlwZSI6ImRvY3giLCJ1cmwiOiJodHRwczovL29ubHlvZmZpY2Uudm9pb24uY29tL2V4YW1wbGUvYXNzZXRzL3NhbXBsZS9zYW1wbGUuZG9jeCIsImRpcmVjdFVybCI6bnVsbCwiaWF0IjoxNjk5NDk2ODAwLCJleHAiOjE2OTk0OTcxMDB9.I-uAR6NV7tyhEXVdOFPNgNk3d57GJE6qF0d242ZaY3I"
				// });
			},
		};

		onMounted(() => {
			const materialId = params.fileId as string;
			const deviceType = parseInt(params.device as string);

			loadingConfig(materialId, deviceType);
		});

		/* 监听窗口关闭事件，并在关闭时销毁 DocumentEditor对象 */
		window.addEventListener('beforeunload', function () {
			const editors = window.DocEditor?.instances?.docEditor;

			if (editors) {
				editors.destroyEditor();
			}

			clear(); // 清除水印
		});

		return () => <div style='width:100%; height:100%'>{!unref(isConfigLoaded) ? <div v-loading='true' element-loading-text='正在加载文档，请稍后' element-loading-background='rgba(122, 122, 122, 0.3)' style='width:100%; height:100%'></div> : <DocumentEditor id='docEditor' type='mobile' documentServerUrl={unref(docJsApi)} config={unref(editorConfig)!} events_onAppReady={methods.onAppReady} events_onRequestHistoryClose={methods.onHistoryClosed} events_onRequestHistory={methods.requestHistory} events_onRequestHistoryData={methods.requestHistoryData} events_onRequestCompareFile={methods.requestCompareFile} />}</div>;
	},
});
